import React from "react";
import { connect } from "react-redux";
import locRU from "../../locale/ru.json";
import locEN from "../../locale/en.json";
import nestedProperty from "../../utils/nested-property/nested-property";
const Localized = props => {
    let { lang, children } = props;
    lang = typeof lang === "string" ? lang.toLowerCase() : lang;
    const locStorage = lang === "ru" ? locRU : lang === "en" ? locEN : locRU;

    const loc = _key => nestedProperty(locStorage, _key);
    return (
        <>
            {React.Children.map(children, child => {
                const newChild = React.cloneElement(child, { loc, lang, ...props });
                return newChild;
            })}
        </>
    );
};

const mapStateToProps = ({
    reportApp: {
        app: {
            settings: { lang }
        }
    }
}) => {
    return {
        lang
    };
};

export default connect(mapStateToProps)(Localized);
